import React from 'react';

type Props = {
  style?: React.CSSProperties;
  children: React.ReactNode;
};

export function PromoPanelContainer(props: Props) {
  return (
    <div
      style={{
        backgroundColor: '#f15e11',
        color: 'white',
        padding: '32px 40px',
        ...props.style,
      }}
    >
      {props.children}
    </div>
  );
}
